import React from "react";
import _ from "lodash";
// config
import { ENVIORMENT } from "./../../env";
import { guid } from "./../utils/Utility";
import { Translate } from "./../Language/Translate";
import $ from "jquery";

// Child components
import UserReply from "./UserReply";
import BotHandler from "./BotHandler";
import Slider from "./../Slider/Slider";

import PoweredBy from "./../PoweredBy/PoweredBy";

// Css loadingtoggleRTL
import "./chat-screen.scss";
// images
import collapsclose from "./../../public/images/collapsclose.svg";

class ChatScreen extends React.Component {
  textmsgsend = "";
  constructor(props) {
    super(props);
    this.state = {
      is_bot_visible: false,
      is_conversation_start: false,
      msg: "",
      txtMsg: "",
      chatlogs: [],
      disablebutton: false,
      user:
        sessionStorage.getItem("user") == null
          ? this.generateGuid()
          : sessionStorage.getItem("user"),
      channel: ENVIORMENT.channel,
      ws: new WebSocket(ENVIORMENT.socketUrl),
      attempts: 1,
      is_bot_typing: false,
      isVisibleHumberMenu: false,
      input_disable: false,
      isLiveAgentOpen: false,
      datasearch: []
    };
    this.sendQuickReply = this.sendQuickReply.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);
    this.sendMultiLangQuickReply = this.sendMultiLangQuickReply.bind(this);
    this.toggleLiveAgent = this.toggleLiveAgent.bind(this);
    this.sendMaskReply = this.sendMaskReply.bind(this);
  }

  toggleHumberMenu() {
    this.setState({
      isVisibleHumberMenu: !this.state.isVisibleHumberMenu
    });
  }

  toggleLiveAgent(newStateValue) {
    this.setState(
      {
        isLiveAgentOpen: !_.get(this, "state.isLiveAgentOpen", false)
      },
      () => {
        if (_.get(this, "state.isLiveAgentOpen", false)) {
          window.liveagent.startChatWithWindow(
            "5731U000000YqF2",
            "live-agent-container"
          );
        }
      }
    );
  }

  generateInterval(k) {
    if (this.props.reconnectIntervalInMilliSeconds > 0) {
      return this.props.reconnectIntervalInMilliSeconds;
    }
    return Math.min(30, Math.pow(2, k) - 1) * 1000;
  }
  /* generate of user id start */
  generateGuid() {
    let guId;
    if (this.getCookie("botkit_guid")) {
      guId = guid();
      this.setCookie("botkit_guid", guId, 1);
      return this.getCookie("botkit_guid");
    }
    guId = guid();
    this.setCookie("botkit_guid", guId, 1);
    return guId;
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  /* generate of user id end */

  /* setting up web socket start */
  setupWebsocket() {
    let websocket = this.state.ws;
    websocket.onopen = () => {
      // const greeting_msg =
      //   "hi - " +
      //   _.get(this, "props.avatar", "") +
      //   " - " +
      //   (_.get(this, "props.isRTLFlow", false) ? "Arabic" : "English");
      const greeting_msg =
        '/language_selection{"language": "' +
        (_.get(this, "props.isRTLFlow", false) ? "ar" : "en") +
        '","avatar_name":"' +
        _.get(this, "props.avatar", "") +
        '"}';

      websocket.send(
        JSON.stringify({
          type: "message",
          text: greeting_msg,
          user: _.get(this, "state.user", ""),
          channel: "socket"
        })
      );
    };

    websocket.onmessage = evt => {
      let responseData = JSON.parse(evt.data);
      if (_.get(responseData, "type", "") === "end_session") {
        this.endChatSession();
        return false;
      }
      if (
        _.get(responseData, "text", "") ===
        "Oops...Your session has timed out! We'll have to start over...Do select an option from the menu."
      ) {
        this.endChatSession1();
        // return false;
      }
      if (_.get(responseData, "type", "") === "restart_session") {
        this.resetChatSession();
        return false;
      }
      if (_.get(responseData, "restart", false) === "true") {
        this.resetMainMenu();
        return false;
      }
      if (
        _.get(responseData, "continue_typing", false) === true ||
        _.get(responseData, "type", "") === "typing"
      ) {
        this.setState({ is_bot_typing: true });
        if (_.get(responseData, "continue_typing", false) === true) {
          this.setState(
            {
              chatlogs: [...this.state.chatlogs, JSON.parse(evt.data)]
            },
            () => {
              if (_.get(responseData, "input_disable", false) === "true") {
                this.setState({
                  input_disable: true
                });
              } else {
                this.setState({
                  input_disable: false
                });
              }
            }
          );
        }
      } else {
        this.setState({ is_bot_typing: false });
        this.setState(
          {
            chatlogs: [...this.state.chatlogs, JSON.parse(evt.data)]
          },
          () => {
            console.log(responseData);
            
              if (_.get(responseData, "input_disable", false) === "true") {
                this.setState({
                  input_disable: true
                });
              } else {
                if (
                  _.get(responseData, "content.input_disable", false) === "true"
                ) {
                  this.setState({
                    input_disable: true
                  });
                } else {
                  this.setState({
                    input_disable: false
                  });
                }
              }
            if (
              responseData.type == "search_bar_new" &&
              responseData.input_disable == true
            ) {
              console.log("inside");

              // this.interval = setInterval(() => this.scrollToBottom(), 5000);

              // this.scrollToBottom();
              this.setState({
                input_disable: true
              });
            }
          }
        );
      }

      this.scrollToBottom();
    };
    websocket.onclose = () => {
      if (typeof this.props.onClose === "function") this.props.onClose();
      if (this.shouldReconnect) {
        let time = this.generateInterval(this.state.attempts);
        this.timeoutID = setTimeout(() => {
          this.setState({ attempts: this.state.attempts + 1 });
          this.setState({
            ws: new WebSocket(this.props.url, this.props.protocol)
          });
          this.setupWebsocket();
        }, time);
      }
    };
  }
  /* setting up web socket end */
  /*
    Send message on enter of textbox or onclick of send button
  */
  sendMessage(e) {
    this.setState({ txtMsg: e.target.value });
    if (
      e.key === "Enter" &&
      e.target.value !== "" &&
      !e.target.value.match(/^\s+$/)
    ) {
      console.log("inside");
      this.sendUserReply(e.target.value);
      this.scrollToBottom();
      // this.setState(
      //   {
      //     disablebutton: true
      //   },
      //   () => {
      //     return <BotHandler disablebutton={this.state.disablebutton} />;
      //   }
      // );
    }
  }

  sendMessageBtn(e) {
    console.log(this.state.txtMsg);
    if (
      _.get(this, "state.txtMsg", "") !== "" &&
      this.state.txtMsg !== "" &&
      !this.state.txtMsg.match(/^\s+$/)
    ) {
      this.sendUserReply(_.get(this, "state.txtMsg", ""));
      this.scrollToBottom();
    }
  }

  sendUserReply(message) {
    this.setState({ msg: message, txtMsg: "" });
    this.textmsgsend = message;
    let chatlogs = this.state.chatlogs;
    chatlogs.push({
      is_received: false,
      text: message
    });
    this.setState({
      chatlogs: chatlogs
    });
    let websocket = this.state.ws;
    websocket.send(
      JSON.stringify({
        type: "message",
        text: message,
        user: _.get(this, "state.user", ""),
        channel: "socket"
      })
    );
    this.scrollToBottom();
  }

  /* send multi language quick reply */
  sendMultiLangQuickReply(quickreply, displayReply = true) {
    if (displayReply) {
      try {
        quickreply = JSON.parse(quickreply);
      } catch (e) {}
      let displayMessage = "";
      let payload = [];
      sessionStorage.setItem("quickreply", JSON.stringify(quickreply));
      if (Array.isArray(quickreply)) {
        const arr_replies = quickreply;
        arr_replies.map((quickreply, index) => {
          displayMessage = displayMessage + quickreply.title + ", ";
          payload.push(quickreply.payload);
        });
        displayMessage = displayMessage.slice(0, -2);
      } else {
        displayMessage = quickreply.title;
        payload.push(quickreply.payload);
      }
      let chatlogs = _.get(this, "state.chatlogs", []);
      chatlogs.push({
        is_received: false,
        text: displayMessage
      });
      this.setState({
        chatlogs: chatlogs
      });

      let websocket = this.state.ws;

      websocket.send(
        JSON.stringify({
          type: "message",
          text: Array.isArray(quickreply)
            ? JSON.stringify(payload)
            : payload.toString(),
          user: _.get(this, "state.user", ""),
          channel: "socket"
        })
      );
    }
  }
  /*
    send quick replies list
  */
  sendQuickReply(quickreply, displayReply = true) {
    if (displayReply) {
      let rangemessage = "";
      let chatlogs = _.get(this, "state.chatlogs", []);
      chatlogs.push({
        is_received: false,
        text: quickreply
      });
      this.setState({
        chatlogs: chatlogs
      });
    }
    if (
      quickreply == '{"Cancel":"Cancel"}' ||
      quickreply == '{"data":{"editdata":""}}'
    ) {
      quickreply = '{"Cancel"}';
    }
    if (quickreply == '{"End":"End"}') {
      sessionStorage.removeItem("init_chat");
      sessionStorage.removeItem("chatlogs");
      sessionStorage.removeItem("quickreply");
      sessionStorage.removeItem("user");
      this.setState(
        {
          chatlogs: [],
          isVisibleHumberMenu: false
        },
        () => {
          // this.sendMessageToBot("end");
          this.props.endConversation();
        }
      );
    }
    if (quickreply == '{"Restart":"Restart"}') {
      sessionStorage.removeItem("chatlogs");
      sessionStorage.removeItem("quickreply");
      this.setState(
        {
          chatlogs: [],
          isVisibleHumberMenu: false
        },
        () => {
          this.sendMessageToBot("/restart");
          const greeting_msg =
            '/language_selection{"language": "' +
            (_.get(this, "props.isRTLFlow", false) ? "ar" : "en") +
            '","avatar_name":"' +
            _.get(this, "props.avatar", "") +
            '"}';

          setTimeout(() => {
            this.sendMessageToBot(greeting_msg);
          }, 1500);
        }
      );
    }
    if (quickreply === '{"End":"End"}') {
    } else if (quickreply === '{"Restart":"Restart"}') {
    } else {
      console.log("Sent mesage" + quickreply);
      let websocket = this.state.ws;
      websocket.send(
        JSON.stringify({
          type: "message",
          text: quickreply,
          user: _.get(this, "state.user", ""),
          channel: "socket"
        })
      );
    }
  }

  sendMaskReply(displayMessage, payload) {
    let chatlogs = _.get(this, "state.chatlogs", []);
    chatlogs.push({
      is_received: false,
      text: displayMessage
    });
    this.setState({
      chatlogs: chatlogs
    });
    let websocket = this.state.ws;
    websocket.send(
      JSON.stringify({
        type: "message",
        text: payload,
        user: _.get(this, "state.user", ""),
        channel: "socket"
      })
    );
  }

  componentDidMount() {
    // console.log();
    // this.setState({
    //   ws: new WebSocket(ENVIORMENT.socketUrl)
    // });

    $(document).click(function() {
      let hideMe = document.getElementById("hideMe");
      if (hideMe != undefined) {
        if (hideMe.className == "menu-pops arrow_box ") {
          hideMe.className = "menu-pops arrow_box hide";
        }
      }
      // hideMe.className = 'menu-pops arrow_box hide';
      // hideMe.style.display= 'none';
      // alert('clicked outside');
    });
    $("#menuWraper").click(function(event) {
      let hideMe = document.getElementById("hideMe");

      // hideMe.style.display= 'block';
      if (hideMe.className == "menu-pops arrow_box hide") {
        hideMe.className = "menu-pops arrow_box ";
      } else {
        hideMe.className = "menu-pops arrow_box hide";
      }
      //alert('clicked inside');
      event.stopPropagation();
    });

    this.scrollToBottom();
    sessionStorage.setItem("init_chat", JSON.stringify(this.props));
    const chatlogs = JSON.parse(sessionStorage.getItem("chatlogs"));

    // if (_.get(this, "state.user", "") == "") {
    //   const botkit_guid = this.generateGuid();
    //   this.setCookie("botkit_guid", botkit_guid, 1);
    //   this.setState({user:botkit_guid});
    //   if (sessionStorage.getItem("user") == null){
    //     sessionStorage.setItem("user",botkit_guid);
    //   }
    // }
    if (sessionStorage.getItem("user") == null) {
      sessionStorage.setItem("user", _.get(this, "state.user", ""));
    }
    // else{
    //   this.setCookie("botkit_guid", sessionStorage.getItem("user"), 1);
    //   // this.setState({user:sessionStorage.getItem("user")});
    // }
    if (chatlogs != null && chatlogs.length > 0) {
      let websocket = this.state.ws;
      websocket.onopen = () => {
        // const greeting_msg =
        //   "hi - " +
        //   _.get(this, "props.avatar", "") +
        //   " - " +
        //   (_.get(this, "props.isRTLFlow", false) ? "Arabic" : "English");
        /* comment */
        if (chatlogs.length < 3) {
          sessionStorage.removeItem("chatlogs");
          const greeting_msg =
            '/language_selection{"language": "' +
            (_.get(this, "props.isRTLFlow", false) ? "ar" : "en") +
            '","avatar_name":"' +
            _.get(this, "props.avatar", "") +
            '"}';
          websocket.send(
            JSON.stringify({
              type: "message",
              text: greeting_msg,
              user: _.get(this, "state.user", ""),
              channel: "socket"
            })
          );
        } else {
          this.setState({ chatlogs: chatlogs }, () => {});
          // chatlogs[chatlogs.length-1]
          const chatlog_last = _.last(_.get(this, "state.chatlogs", []));

          if (
            chatlog_last.is_received != undefined &&
            !chatlog_last.is_received &&
            sessionStorage.getItem("quickreply") != null
          ) {
            _.get(this, "state.chatlogs", []).pop();

            this.sendMultiLangQuickReply(
              JSON.parse(sessionStorage.getItem("quickreply"))
            );
          } else if (
            chatlog_last.is_received != undefined &&
            !chatlog_last.is_received
          ) {
            _.get(this, "state.chatlogs", []).pop();
            this.sendUserReply(chatlog_last.text);
          }
        }
      };
      websocket.onmessage = evt => {
        let responseData = JSON.parse(evt.data);
        if (_.get(responseData, "type", "") === "end_session") {
          this.endChatSession();
          return false;
        }
        if (
          _.get(responseData, "text", "") ===
          "Oops...Your session has timed out! We'll have to start over...Do select an option from the menu."
        ) {
          this.endChatSession1();
          return false;
        }
        if (_.get(responseData, "type", "") === "restart_session") {
          this.resetChatSession();
          return false;
        }
        if (_.get(responseData, "restart", false) === "true") {
          this.resetMainMenu();
          return false;
        }
        if (
          _.get(responseData, "continue_typing", false) === true ||
          _.get(responseData, "type", "") === "typing"
        ) {
          this.setState({ is_bot_typing: true });
          if (_.get(responseData, "continue_typing", false) === true) {
            this.setState(
              {
                chatlogs: [...this.state.chatlogs, JSON.parse(evt.data)]
              },
              () => {
                if (_.get(responseData, "input_disable", false) === "true") {
                  this.setState({
                    input_disable: true
                  });
                } else {
                  this.setState({
                    input_disable: false
                  });
                }
              }
            );
            sessionStorage.removeItem("quickreply");
          }
        } else {
          this.setState({ is_bot_typing: false });
          this.setState(
            {
              chatlogs: [...this.state.chatlogs, JSON.parse(evt.data)]
            },
            () => {
              if (_.get(responseData, "input_disable", false) === "true") {
                this.setState({
                  input_disable: true
                });
              } else {
                if (
                  _.get(responseData, "content.input_disable", false) === "true"
                ) {
                  this.setState({
                    input_disable: true
                  });
                } else {
                  this.setState({
                    input_disable: false
                  });
                }
              }
            }
          );
          sessionStorage.removeItem("quickreply");
        }

        this.scrollToBottom();
      };
      this.scrollToBottom();
    } else {
      this.setConversation();
    }
    this.scrollToBottom();
  }

  setConversation() {
    // this.scrollToBottom();
    this.setupWebsocket();
    this.setState(
      {
        chatlogs: [
          {
            is_received: true,
            type: "load_big_avatar"
          },

          // ,{
          //   is_received: true,
          //   type: "image",
          //   "data": {
          //      "image_type": "url",
          //      "image": "http://www.medcare.ae/public/uploads/doctor/Leo_(3).jpg",
          //   }
          // },

          // ,{
          //   is_received: true,
          //   "text":"Perfect! How are you feeling today? <a href='http://google.com' target='_blank'>google</a>","quick_replies":[{"title":"haha ","payload":"I'm alright"},{"title":"eeeeee 🤒","payload":"Not too good!"}],"channel":"socket","sent_timestamp":1549283151386,"user":"d4cfb5df-1fc7-6534-f980-9f6bd8f7e569","to":"d4cfb5df-1fc7-6534-f980-9f6bd8f7e569","type":"message"
          // },
          // {
          //   is_received: false,
          //   "text":"Perfect! How are you feeling today?","quick_replies":[{"title":"haha ","payload":"I'm alright"},{"title":"eeeeee 🤒","payload":"Not too good!"}],"channel":"socket","sent_timestamp":1549283151386,"user":"d4cfb5df-1fc7-6534-f980-9f6bd8f7e569","to":"d4cfb5df-1fc7-6534-f980-9f6bd8f7e569","type":"message"
          // }

          // ,{
          //   text:
          //     "I'm trained to help you in both English & Arabic. What would you prefer?",
          //   quick_replies: [
          //     { title: "English", payload: "English" },
          //     { title: "Arabic", payload: "Arabic" }
          //   ],
          //   channel: "socket",
          //   sent_timestamp: 1549270147855,
          //   user: "d4cfb5df-1fc7-6534-f980-9f6bd8f7e569",
          //   to: "d4cfb5df-1fc7-6534-f980-9f6bd8f7e569",
          //   type: "language_selection"
          // },
          // ,{ is_received: true,
          //   "type":"multi_select",
          //   "text":"I'm trained to help you in both English & Arabic. What would you prefer?",
          //   "quick_replies":[
          //     {"title":"English","payload":"English"},
          //     {"title":"Arabic","payload":"Arabic"},
          //     {"title":"Hindi","payload":"Hindi"},
          //     {"title":"Gujarati","payload":"Gujarati"},
          //     {"title":"Marathi","payload":"Marathi"},
          //   ]
          //   ,
          //   "channel":"socket",
          //   "sent_timestamp":1549017262630,"user":"064db488-99ba-3ee9-3bf7-b4e099645365",
          //   "to":"064db488-99ba-3ee9-3bf7-b4e099645365"
          // }
          //  {
          //   is_received: true,
          //   type: "download",
          //   text: "download",
          //   channel: "socket",
          //   //data:[{"filename": "\\\\10.10.8.23\\files\\0900341580c489567.pdf"}]
          //   data:[{"filename": "http://www.pdf995.com/samples/pdf.pdf"}]
          // }
          //  ,{
          //   is_received: true,
          //   type: "new_tab",
          //   text: "open new tab",
          //   channel: "socket",
          //   data:[{"url": "http://www.pdf995.com/samples/pdf.pdf"}]
          // }
          // ,{
          //   is_received: true,

          //   "channel": "socket",

          //       type: "get_map_direction",
          //       text: "get_map_direction",
          //       data: [{
          //         from : {
          //           "lat": "18.5918294",
          //           "lng": "73.733393"
          //          },
          //         to: {
          //           "lat": "18.5793481",
          //           "lng": "73.9067281"
          //           }
          //       }]

          // }
          // {
          //   is_received: true,
          //   type: "auth_form",
          //   channel: "socket"
          //  }
          // ,{
          //   is_received: true,
          //   "type": "list",
          //   "input_disable": "true",
          //   "channel": "socket",
          //     "data": [
          //     {
          //       "label": "Doctor",
          //       "description": "I know my Doctor.",
          //       "image_type": "name",
          //       "image": "Doctor.jpg",
          //       "buttons": [
          //           { "title": "Doctor", "payload": "Doctor" }
          //         ]
          //     }, {
          //       "label": "Specialisation",
          //       "description": "I know my Specialisation.",
          //       "image_type": "name",
          //       "image": "Specialization.jpg",
          //       "buttons": [
          //           { "title": "Specialization", "payload": "Specialization" }
          //         ]
          //     }, {
          //       "label": "Symptom Analyser",
          //       "description": "I know my Symptom.",
          //       "image_type": "name",
          //       "image": "SymptomAnalyzer.jpg",
          //       "buttons": [
          //           { "title": "SymptomAnalyzer", "payload": "SymptomAnalyzer" }
          //         ]
          //     }
          //   ]
          // }
          // { "type": "daynamic_search_bar", "channel": "socket", "data": [{ "title": "Anesthesiology", "payload": "/selected_specialization{\"specialization\": \"Anesthesiology\"}" }, { "title": "Audiology", "payload": "/selected_specialization{\"specialization\": \"Audiology\"}" }, { "title": "Bariatric Surgery", "payload": "/selected_specialization{\"specialization\": \"Bariatric Surgery\"}" }, { "title": "Cardiology", "payload": "/selected_specialization{\"specialization\": \"Cardiology\"}" }, { "title": "Cardiology, Interventional Cardiology", "payload": "/selected_specialization{\"specialization\": \"Cardiology, Interventional Cardiology\"}" }, { "title": "Consultant Vascular Surgeon ", "payload": "/selected_specialization{\"specialization\": \"Consultant Vascular Surgeon \"}" }, { "title": "Dentistry", "payload": "/selected_specialization{\"specialization\": \"Dentistry\"}" }, { "title": "Dentistry, Plastic Surgery", "payload": "/selected_specialization{\"specialization\": \"Dentistry, Plastic Surgery\"}" }, { "title": "Dermatology", "payload": "/selected_specialization{\"specialization\": \"Dermatology\"}" }, { "title": "Dermatology & Venereology", "payload": "/selected_specialization{\"specialization\": \"Dermatology & Venereology\"}" }, { "title": "Diet & Nutrition", "payload": "/selected_specialization{\"specialization\": \"Diet & Nutrition\"}" }, { "title": "E.N.T", "payload": "/selected_specialization{\"specialization\": \"E.N.T\"}" }, { "title": "E.N.T. & Rhinoplasty", "payload": "/selected_specialization{\"specialization\": \"E.N.T. & Rhinoplasty\"}" }, { "title": "Embryology & Andrology", "payload": "/selected_specialization{\"specialization\": \"Embryology & Andrology\"}" }, { "title": "Endocrinology", "payload": "/selected_specialization{\"specialization\": \"Endocrinology\"}" }, { "title": "Family Medicine", "payload": "/selected_specialization{\"specialization\": \"Family Medicine\"}" }, { "title": "Gastroenterology", "payload": "/selected_specialization{\"specialization\": \"Gastroenterology\"}" }, { "title": "Gastroenterology & Hepatology", "payload": "/selected_specialization{\"specialization\": \"Gastroenterology & Hepatology\"}" }, { "title": "General Practise", "payload": "/selected_specialization{\"specialization\": \"General Practise\"}" }, { "title": "General Surgery", "payload": "/selected_specialization{\"specialization\": \"General Surgery\"}" }, { "title": "Hematology", "payload": "/selected_specialization{\"specialization\": \"Hematology\"}" }, { "title": "Internal Medicine", "payload": "/selected_specialization{\"specialization\": \"Internal Medicine\"}" }, { "title": "Laparoscopic & General Surgery", "payload": "/selected_specialization{\"specialization\": \"Laparoscopic & General Surgery\"}" }, { "title": "Laparoscopic, Bariatric & General Surgery", "payload": "/selected_specialization{\"specialization\": \"Laparoscopic, Bariatric & General Surgery\"}" }, { "title": "Neonatology", "payload": "/selected_specialization{\"specialization\": \"Neonatology\"}" }, { "title": "Nephrology", "payload": "/selected_specialization{\"specialization\": \"Nephrology\"}" }, { "title": "Neurology", "payload": "/selected_specialization{\"specialization\": \"Neurology\"}" }, { "title": "Neurosurgery", "payload": "/selected_specialization{\"specialization\": \"Neurosurgery\"}" }, { "title": "Obstetrics & Gynaecology", "payload": "/selected_specialization{\"specialization\": \"Obstetrics & Gynaecology\"}" }, { "title": "Obstetrics & Gynecology", "payload": "/selected_specialization{\"specialization\": \"Obstetrics & Gynecology\"}" }, { "title": "Ophthalmology", "payload": "/selected_specialization{\"specialization\": \"Ophthalmology\"}" }, { "title": "Opthalmology", "payload": "/selected_specialization{\"specialization\": \"Opthalmology\"}" }, { "title": "Oral & Maxillofacial Surgery", "payload": "/selected_specialization{\"specialization\": \"Oral & Maxillofacial Surgery\"}" }, { "title": "Orthopaedics", "payload": "/selected_specialization{\"specialization\": \"Orthopaedics\"}" }, { "title": "Paediatric Ophthalmology", "payload": "/selected_specialization{\"specialization\": \"Paediatric Ophthalmology\"}" }, { "title": "Paediatrics", "payload": "/selected_specialization{\"specialization\": \"Paediatrics\"}" }, { "title": "Paediatrics & Neonatology", "payload": "/selected_specialization{\"specialization\": \"Paediatrics & Neonatology\"}" }, { "title": "Pediatric Neurology", "payload": "/selected_specialization{\"specialization\": \"Pediatric Neurology\"}" }, { "title": "Pediatric Surgery", "payload": "/selected_specialization{\"specialization\": \"Pediatric Surgery\"}" }, { "title": "Pediatrician", "payload": "/selected_specialization{\"specialization\": \"Pediatrician\"}" }, { "title": "Plastic Surgery", "payload": "/selected_specialization{\"specialization\": \"Plastic Surgery\"}" }, { "title": "Prosthodontist & Implantologist", "payload": "/selected_specialization{\"specialization\": \"Prosthodontist & Implantologist\"}" }, { "title": "Psychiatry", "payload": "/selected_specialization{\"specialization\": \"Psychiatry\"}" }, { "title": "Pulmonology", "payload": "/selected_specialization{\"specialization\": \"Pulmonology\"}" }, { "title": "Rheumatology", "payload": "/selected_specialization{\"specialization\": \"Rheumatology\"}" }, { "title": "Rheumotology", "payload": "/selected_specialization{\"specialization\": \"Rheumotology\"}" }, { "title": "Spine, Sports Medicine", "payload": "/selected_specialization{\"specialization\": \"Spine, Sports Medicine\"}" }, { "title": "Sports Medicine", "payload": "/selected_specialization{\"specialization\": \"Sports Medicine\"}" }, { "title": "Urology", "payload": "/selected_specialization{\"specialization\": \"Urology\"}" }, { "title": "Vascular Surgery", "payload": "/selected_specialization{\"specialization\": \"Vascular Surgery\"}" }], "input_disable": "true", "text": "Choose Specialization" }
          // , {
          //   is_received: true,
          //   input_disable: true,
          //   "type": "search_bar", "text": "Enter Specialisation", "data": ["التخدير", "ANESTHESIOLOGY", "AUDIOLOGY", "BARIATRIC SURGERY", "CARDIOLOGY", "DENTISTRY", "DERMATOLOGY", "DIET & NUTRITION", "E.N.T", "EMERGENCY", "ENDOCRINOLOGYFAMILY", "MEDICINE", "FERTILITY", "GASTROENTEROLOGY", "GENERAL", "SURGERY", "HEMATOLOGYINTERNAL", "MEDICINE", "NEONATOLOGY", "NEUROLOGY", "NEUROSURGERY", "OBSTETRICS & GYNECOLOGY", "OPHTHALMOLOGY", "ORTHOPAEDICS", "PAEDIATRICS", "PEDIATRIC SURGERY", "PHYSIOTHERAPY", "PLASTIC SURGERY", "PSYCHIATRY", "PULMONOLOGY", "RADIOLOGY", "RHINOPLASTY", "UROLOGY"], "channel": "socket", "sent_timestamp": 1548310688613, "user": "bfacec25-f00a-4ebe-7c9d-bf4066f44d65", "to": "bfacec25-f00a-4ebe-7c9d-bf4066f44d65"
          // }

          //  ,{
          //    is_received: true,
          //    input_disable: true,
          //    "type":"search_bar_new","text":"Enter Specialisation",
          //    "data": ["data", "sanay"],"channel":"socket","sent_timestamp":1548310688613,"user":"bfacec25-f00a-4ebe-7c9d-bf4066f44d65","to":"bfacec25-f00a-4ebe-7c9d-bf4066f44d65"
          //  },
          // {
          //   is_received: true,
          //   input_disable: true,
          //   type: "search_bar_1",
          //   text: "Enter Specialisation",
          //   data: [
          //     "التخدير",
          //     "ANESTHESIOLOGY",
          //     "AUDIOLOGY",
          //     "BARIATRIC SURGERY",
          //     "CARDIOLOGY",
          //     "DENTISTRY",
          //     "DERMATOLOGY",
          //     "DIET & NUTRITION",
          //     "E.N.T",
          //     "EMERGENCY",
          //     "ENDOCRINOLOGYFAMILY",
          //     "MEDICINE",
          //     "FERTILITY",
          //     "GASTROENTEROLOGY",
          //     "GENERAL",
          //     "SURGERY",
          //     "HEMATOLOGYINTERNAL",
          //     "MEDICINE",
          //     "NEONATOLOGY",
          //     "NEUROLOGY",
          //     "NEUROSURGERY",
          //     "OBSTETRICS & GYNECOLOGY",
          //     "OPHTHALMOLOGY",
          //     "ORTHOPAEDICS",
          //     "PAEDIATRICS",
          //     "PEDIATRIC SURGERY",
          //     "PHYSIOTHERAPY",
          //     "PLASTIC SURGERY",
          //     "PSYCHIATRY",
          //     "PULMONOLOGY",
          //     "RADIOLOGY",
          //     "RHINOPLASTY",
          //     "UROLOGY"
          //   ],
          //   channel: "socket",
          //   sent_timestamp: 1548310688613,
          //   user: "bfacec25-f00a-4ebe-7c9d-bf4066f44d65",
          //   to: "bfacec25-f00a-4ebe-7c9d-bf4066f44d65"
          // }
          // ,{
          //   is_received: true,
          //   type: "auth_form",
          //   channel: "socket"
          // }
          // ,{
          //   is_received: true,
          //   type: "otp",
          //   channel: "socket"
          // },
          // {
          //   type: "end_session",
          //   text: "End Session....",
          //   channel: "socket"
          // },
          // {
          //   type: "restart_session",
          //   text: "Restart Session....",
          //   channel: "socket"
          // }
          // {
          //   text: "Oops Your session has ended, please.. . ...",
          //   quick_replies: [
          //     {
          //       title: "End Session",
          //       payload: "endsession()"
          //     },
          //     {
          //       title: "Restart Session",
          //       payload: "restartsession()"
          //     }
          //   ],
          //   channel: "socket",
          //   type: "session"
          // }
          // ,{
          //   is_received: true,
          //   type: "date",
          //   text: "date-picker",
          //   channel: "socket",
          //   range: "future"
          // }
          // , { is_received: true,
          //   "type": "carousel",
          //   "text": "You could either pick one of the following or just type out what you're looking for...📝",
          //   "data": [
          //     {
          //       "label": "Manage Appointments",
          //       "description": "You could either pick one of the following or just type out what you're looking for...📝",
          //       "image_type": "name",
          //       "image": "Medcare Medical Centre Motor Cit.png",
          //       "buttons": [
          //         { "title": "Book Appointment", "payload": "Book Appointment" },
          //         { "title": "Reschedule Appointment", "payload": "Reschedule Appointment" },
          //         { "title": "Cancel Appointment", "payload": "Cancel Appointment" }
          //       ]
          //     }],

          //   },
          // , { is_received: true,
          //   "type": "carousel-button",
          //   "text": "You could either pick one of the following or just type out what you're looking for...📝",
          //   "data": [
          //     {
          //       "label": "Manage Appointments",
          //       "description": "You could either pick one of the following or just type out what you're looking for...📝",
          //       "image_type": "name",
          //       "image": "Medcare Medical Centre Motor Cit.png",
          //       "buttons": [
          //         { "title": "Book Appointments", "payload": "Book Appointment" },
          //         { "title": "Reschedule Appointment", "payload": "Reschedule Appointment" },
          //         { "title": "Cancel Appointment", "payload": "Cancel Appointment" }
          //       ],
          //     }
          //   ],
          //   "Submitdata":
          //     { "title": "Submit", "link": "http://thatsbluelogic.com/BL-Chatbot-.php" },

          //   },

          //     { "label": "Locate a Centre", "description": "", "image_type": "url", "image": "https://www.medcare.ae/public/uploads/doctor/ihab-ramadan.jpg", "buttons": [{ "title": "Find me a centre", "payload": "Find me a centre" }, { "title": "View all centres", "payload": "View all centres" }] }, { "label": "Symptom Analyser", "description": "", "image_type": "name", "image": "SymptomChecker.jpg", "buttons": [{ "title": "Check your Symptoms", "payload": "Check your Symptoms" }] }], "channel": "socket", "sent_timestamp": 1548236243318, "user": "ec7f2c61-3e3c-bf5c-bccf-a67cf3386a07", "to": "ec7f2c61-3e3c-bf5c-bccf-a67cf3386a07" }
          // ,{
          //   is_received: true,
          //   type: "new_user_form",
          //     channel: "socket",
          //     content: {
          //         type: "new_user_form",
          //         text: "Super! I would appreciate it if you could fill out the form (for the patient) below to help me book you in. 😎"
          //     }
          // }
          // ,{
          //   is_received: true,
          //   type: "existing_user_form",
          //   channel: "socket",
          // }
          // ,{
          //   is_received: true,
          //   type: "callback_form",
          //   channel: "socket",
          //   input_disable: "true",
          // }
          // , {
          //   is_received: true,
          //   type: "range_slider",
          //   channel: "socket",
          //   input_disable: false,
          //   data: {
          //     min: 0,
          //     max: 40,
          //     step: 4
          //   }
          // }
          // ,{
          //   is_received: true,
          //   type: "get_user_location",
          //   channel: "socket",
          // }
          // ,{"type":"carousel","text":"profileCarousel","data":[{"label":"Dr Mousumee Nanda","description":"Specialist Dermatology",
          // "image_type":"url","image":"https://www.medcare.ae/public/uploads/doctor/Leo_(3).jpg","buttons":[{"title":"Book Now!","payload":"Book Now"},{"title":"Change Preference","payload":"Change Preference"}]}],"channel":"socket","sent_timestamp":1550578358276,"user":"3f2e79bf-f5af-0d9a-6834-1f65a3cd16fb","to":"3f2e79bf-f5af-0d9a-6834-1f65a3cd16fb"}
          // ,{
          //   "text": "image",
          //   "type": "image",
          //   "data" : [{
          //       "image_type": "name",
          //       "image": "Apple.jpg"
          //   }]
          // }
          // ,{"is_received":true,"type":"carousel","font":"neutral","text":"centreListCarousel","data":[{"description":"2.871 كم","image_type":"name","image":"Medcare Hospital Sharjah.jpg","buttons":[{"title":"الاتجهات","payload":"Get Directions - Medcare Hospital Sharjah"},{"title":"الأقسام الطبية","payload":"View Specialisations - Medcare Hospital Sharjah"}]},{"description":"4.152 كم","image_type":"name","image":"Medcare Medical Centre JBR.jpg","buttons":[{"title":"الاتجهات","payload":"Get Directions - Medcare Medical Centre JBR"},{"title":"الأقسام الطبية","payload":"View Specialisations - Medcare Medical Centre JBR"}]}],"channel":"socket","sent_timestamp":1552653991294,"user":"a0489e10-dd35-a49d-561c-66e6ece2db06","to":"a0489e10-dd35-a49d-561c-66e6ece2db06"}
          // ,{
          //   is_received: true,
          //   type: "chat_with_liveagent",
          //   channel: "socket",
          // }
          // ,{
          //   is_received: true,
          //   type: "chat_transcript",
          //   channel: "socket",
          // }
          // ,{
          //   is_received: true,
          //   type: "get_user_name",
          //   channel: "socket",
          // }
          // {
          //   is_received: true,
          //   type: "daynamic_form",
          //   channel: "socket",
          //   data: {
          //     fields: [
          //       {
          //         type: "text",
          //         label: "Name",
          //         data: "name",
          //         value: "",
          //         required: true
          //       },

                // //       //  {
                // //       //   type: "textarea",
                // //       //   label: "Description",
                // //       //   data: "description",
                // //       //   value: "",
                // //       //   required: false,
                // //       // },

                //       {
                //         type: "email",
                //         label: "Email",
                //         data: "email",
                //         value: "",
                //         required: true,
                //       },

                // {
                //   type: "date",
                //   label: "Date",
                //   data: "date",
                //   pastyear: false,
                //   value: "",
                //   required: true
                // },
                //       {
                //         type: "phone",
                //         label: "Phone",
                //         data: "phone",
                //         value: "",
                //         required: true,
                //       },
                // // // //        {
                // // // //         type: "otp",
                // // // //         label: "Otp",
                // // // //         channel: "socket",
                // // // //         data: "otp",
                // // // //         value: "",
                // // // //         required: false,
                // // // //       },
                //       // {
                //       //   type: "password",
                //       //   data: "password",
                //       //   label: "Password",
                //       //   value: "",
                //       //   required: true
                //       // },
                // //       // {
                // //       //   type: "time",
                // //       //   data: "time",
                // //       //   label: "Time",
                // //       //   value: "",
                // //       //   required: false
                // //       // },

                // //   //     {
                // //   //       type: "checkbox",
                // //   //       data: "checkbox",
                // //   //       label: "Checkbox",
                // //   //       value: "",
                // //   //           "data":[ {
                // //   //       title: "ANESTHESIOLOGY",
                // //   //       payload: "ANESTHESIOLOGY"
                // //   //     },

                // //   //     {
                // //   //       title: "AUDIOLOGY",
                // //   //       payload: "AUDIOLOGY"
                // //   //     },
                // //   //     {
                // //   //       title: "BARIATRIC SURGERY",
                // //   //       payload: "BARIATRIC SURGERY"
                // //   //     },
                // //   //     {
                // //   //       title: "CARDIOLOGY",
                // //   //       payload: "CARDIOLOGY"
                // //   //     },
                // //   //     {
                // //   //       title: "DENTISTRY",
                // //   //       payload: "DENTISTRY"
                // //   //     },
                // //   //   ],
                // //   //     }
                // //   //   ]}}
                // //     //     required: true
                // //     //   },
                // //     //   {
                // //     //     type: "radiobox",
                // //     //     data: "radiobox",
                // //     //     label: "Speciality",
                // //     //     value: "",
                // //     //     "data":[ {
                // //     //     title: "ANESTHESIOLOGY",
                // //     //     payload: "1"
                // //     //   },
                // //     //   {
                // //     //     title: "AUDIOLOGY",
                // //     //     payload: "2"
                // //     //   },
                // //     //   {
                // //     //     title: "BARIATRIC SURGERY",
                // //     //     payload: "BARIATRIC SURGERY"
                // //     //   },
                // //     //   {
                // //     //     title: "CARDIOLOGY",
                // //     //     payload: "CARDIOLOGY"
                // //     //   },
                // //     //   {
                // //     //     title: "DENTISTRY",
                // //     //     payload: "DENTISTRY"
                // //     //   },
                // //     // ],
                // //     //     required: true
                // //     //   },
                // //     //    {
                // //     //     type: "upload",
                // //     //     data: "upload",
                // //     //     label: "Upload",
                // //     //     uploadurl: "wss://test.medcare.t/upload",
                // //     //     value: "",
                // //     //     "data":[ {
                // //     //     allowmultiple: true,
                // //     //     maxfiles : 2,
                // //     //   },
                // //     // ],
                // //     //     required: true
                // //     //   },

          //       {
          //         type: "submit",
          //         label: "Submit"
          //       },
          //       {
          //         type: "cancel",
          //         label: "Cancel"
          //       }
          //     ]
          //   }
          // }

          // }
        ]
      },
      () => {}
    );
  }

  /*
    scroll till an end of chat div
  */
  scrollToBottom = () => {
    try {
      this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    } catch (Exception) {}
  };

  componentDidUpdate() {
    const init_chat = JSON.parse(sessionStorage.getItem("init_chat"));
    if (init_chat == null) {
      sessionStorage.removeItem("chatlogs");
    } else {
      sessionStorage.setItem(
        "chatlogs",
        JSON.stringify(_.get(this, "state.chatlogs", []))
      );
    }

    if (_.get(this, "state.chatlogs", []).length == 0) {
      this.setConversation();
    }

    this.scrollToBottom();
  }

  generateChatHistory(chat, i) {
    // if (responseData.type == "carousel") {
    //   console.log(chat);
    //   $("#l12").removeClass("disabled");
    //   $("#a12").removeClass("disabled");
    // }
    // this.setState({
    //   disablebutton: false
    // });
    if (_.get(chat, "is_received", true) === true) {
      return (
        <BotHandler
          key={i}
          disablebutton={this.state.disablebutton}
          sendQuickReply={this.sendQuickReply}
          txtmsg={_.get(this, "textmsgsend", "")}
          sendMultiLangQuickReply={this.sendMultiLangQuickReply}
          avatar={_.get(this, "props.avatar", "")}
          search={_.get(this, "props.search", "")}
          arabicdatasearch={_.get(this, "props.arabicdatasearch", "")}
          chat={chat}
          chatIndex={i}
          changeLanguage={this.changeLanguage}
          isRTLFlow={_.get(this, "props.isRTLFlow", false)}
          toggleLiveAgent={this.toggleLiveAgent}
          lang={_.get(this, "props.lang", "English")}
          isLiveAgentOpen={_.get(this, "state.isLiveAgentOpen", false)}
          maskReply={this.sendMaskReply}
        />
      );
    } else {
      return (
        <UserReply
          key={i}
          chat={chat}
          isRTLFlow={_.get(this, "props.isRTLFlow", false)}
          lang={_.get(this, "props.lang", "English")}
        />
      );
    }
  }

  resetChatSession() {
    console.log("isnide");

    // ws: new WebSocket(ENVIORMENT.socketUrl);
    sessionStorage.removeItem("chatlogs");
    sessionStorage.removeItem("quickreply");
    // this.setState({
    //   disablebutton: false
    // });
    this.setState(
      {
        chatlogs: [],
        isVisibleHumberMenu: false
      },
      () => {
        this.sendMessageToBot("/restart");
        const greeting_msg =
          '/language_selection{"language": "' +
          (_.get(this, "props.isRTLFlow", false) ? "ar" : "en") +
          '","avatar_name":"' +
          _.get(this, "props.avatar", "") +
          '"}';

        setTimeout(() => {
          this.sendMessageToBot(greeting_msg);
        }, 1500);
      }
    );
    // if (this.state.disablebutton === false) {
      
    //   return <BotHandler disablebutton={this.state.disablebutton} />;
    // }
  }

  resetMainMenu() {
    this.setState(
      {
        isVisibleHumberMenu: false
      },
      () => {
        const greeting_msg =
          "main menu - " +
          (_.get(this, "props.isRTLFlow", false) ? "arabic" : "english");

        this.sendMessageToBot(greeting_msg);
        return false;
      }
    );
  }

  endChatSession() {
    sessionStorage.removeItem("init_chat");
    sessionStorage.removeItem("chatlogs");
    sessionStorage.removeItem("quickreply");
    sessionStorage.removeItem("user");
    this.setState(
      {
        chatlogs: [],
        isVisibleHumberMenu: false
      },
      () => {
        // this.sendMessageToBot("end");
        this.props.endConversation();
      }
    );
  }
  endChatSession1() {
    console.log("inside");
    // let websocket = this.state.ws;
    // // websocket.close();
    // websocket.onclose = () => {
    //   if (typeof this.props.onClose === "function") this.props.onClose();
    //   if (this.shouldReconnect) {
    //     let time = this.generateInterval(this.state.attempts);
    //     this.timeoutID = setTimeout(() => {
    //       this.setState({ attempts: this.state.attempts + 1 });
    //       this.setState({
    //         ws: new WebSocket(this.props.url, this.props.protocol)
    //       });
    //       this.setupWebsocket();
    //     }, time);
    //   }
    // };
    // this.setState({
    //   disablebutton: true
    // });
    // if (this.state.disablebutton === true) {
    //   return <BotHandler disablebutton={this.state.disablebutton} />;
    // }

    //   sessionStorage.removeItem("init_chat");
    // sessionStorage.removeItem("chatlogs");
    // sessionStorage.removeItem("quickreply");
    // sessionStorage.removeItem("user");
    // this.setState(
    //   {
    //     chatlogs: [],
    //     isVisibleHumberMenu: false
    //   },
    //   () => {
    //     // this.sendMessageToBot("end");
    //     this.props.endConversation();
    //   }
    // );
  }

  sendMainMenu() {
    this.sendMessageToBot("/restart");

    setTimeout(() => {
      this.sendMessageToBot("/main_menu");
    }, 1000);

    this.setState({
      isVisibleHumberMenu: false
    });
  }

  sendMessageToBot(message) {
    let websocket = this.state.ws;
    websocket.send(
      JSON.stringify({
        type: "message",
        text: message,
        user: _.get(this, "state.user", ""),
        channel: "socket"
      })
    );
  }

  changeLanguage(lang) {
    this.props.toggleRTL(lang);
  }

  render() {
    const isBotTyping = _.get(this, "state.is_bot_typing", false);
    const isInputDisable = _.get(this, "state.input_disable", false);
    const chatlogs = _.get(this, "state.chatlogs", []);

    return (
      <div className="chat-converstion">
        <div className="container">
          <div className="row">
            <div className="chat-box-header position-relative">
              <div className="float-left headeravtar">
                <img
                  src={require("./../../public/images/bot-avatar-" +
                    _.get(this, "props.avatar", "") +
                    ".png")}
                  alt=""
                />
              </div>
              <div className="col bot-name">
                {_.get(this, "props.avatarDispName", "")}
              </div>
              <span className="box-header-ic d-none">
                <span
                  className="btn-link"
                  onClick={() => this.props.toggleBotButton()}
                >
                  <img src={collapsclose} alt="" />
                </span>
              </span>
            </div>
            <div
              className={
                "chat-body " +
                (_.get(this, "state.isLiveAgentOpen", false) ? "d-none" : "")
              }
            >
              <div className="chat-logs">
                {chatlogs.map((chat, i) => this.generateChatHistory(chat, i))}
                <div
                  style={{ float: "left", clear: "both" }}
                  ref={el => {
                    this.messagesEnd = el;
                  }}
                />
              </div>

              <div className="bottom-part">
                
                  <span
                    id="menuWraper"
                    className="menu_ic position-relative"
                    onClick={() => this.toggleHumberMenu()}
                  >
                    {ENVIORMENT.project === "al-ain" && (
                      <img
                        src={require(`./../../public/images/acc.svg`)}
                        alt=""
                      />
                    )}



                    {ENVIORMENT.project === "medcare" && (
                      <img
                        className="font"
                        src={require(`./../../public/images/11.jpg`)}
                        alt=""
                      />
                    )}
                  </span>
                
                <div
                  id="hideMe"
                  className={
                    "menu-pops arrow_box " +
                    (!_.get(this, "state.isVisibleHumberMenu", false)
                      ? "hide"
                      : "")
                  }
                >
                  {/* <h4
                    className={
                      "p-2" +
                      (_.get(this, "props.isRTLFlow", false)
                        ? " font-arabic "
                        : "")
                    }
                  >
                    {Translate("MAIN", _.get(this, "props.lang"))}
                  </h4> */}
                  <ul>
                    <li>
                      <span
                        className={
                          "p-2" +
                          (_.get(this, "props.isRTLFlow", false)
                            ? " font-arabic "
                            : "")
                        }
                        onClick={() => this.sendMainMenu()}
                      >
                        {Translate("MAIN_MENU", _.get(this, "props.lang"))}
                      </span>
                    </li>
                    <li>
                      <span
                        className={
                          "p-2" +
                          (_.get(this, "props.isRTLFlow", false)
                            ? " font-arabic "
                            : "")
                        }
                        onClick={() => this.resetChatSession()}
                      >
                        {Translate(
                          "RESTART_SESSION",
                          _.get(this, "props.lang")
                        )}
                      </span>
                    </li>
                    <li className="">
                      <span
                        className={
                          "p-2" +
                          (_.get(this, "props.isRTLFlow", false)
                            ? " font-arabic "
                            : "")
                        }
                        onClick={e => {
                          this.toggleHumberMenu();
                          this.sendMessageToBot("Live Agent");
                        }}
                      >
                        {Translate("LIVE_AGENT", _.get(this, "props.lang"))}
                      </span>
                    </li>
                    {/* <li className="">
                      <span
                        id="endSession"
                        className={
                          "p-2 border-bottom-0" +
                          (_.get(this, "props.isRTLFlow", false)
                            ? " font-arabic "
                            : "")
                        }
                        onClick={() => this.endChatSession()}
                      >
                        {Translate("END", _.get(this, "props.lang"))}
                      </span>
                    </li> */}
                  </ul>
                </div>
                <div className="bot-typeing">
                  {isBotTyping && (
                    <div className="ml-1 typing-indicator">
                      <div
                        className={
                          "bot-typer-name" +
                          (_.get(this, "props.isRTLFlow", false)
                            ? " font-arabic-light "
                            : "")
                        }
                      >
                        {Translate(
                          _.get(this, "props.avatarDispName", ""),
                          "avatar"
                        )}
                      </div>
                      <span />
                      <span />
                      <span />
                    </div>
                  )}
                </div>

                <div
                  className={
                    "type-msg mb-1 " +
                    (_.get(this, "props.isRTLFlow", false) ? "hide" : "")
                  }
                >
                  <div className="input-msg-write">
                    <input
                      type="text"
                      maxLength="255"
                      className="mb-2 ml-2"
                      placeholder={Translate(
                        "TYPE_A_MESSAGE",
                        _.get(this, "props.lang", "English")
                      )}
                      autoComplete="off"
                      value={_.get(this, "state.txtMsg", "")}
                      onChange={e => this.sendMessage(e)}
                      onKeyPress={e => this.sendMessage(e)}
                      disabled={
                        _.get(this, "props.isRTLFlow", false) || isInputDisable
                          ? "disabled"
                          : ""
                      }
                    />
                    <button
                      disabled={
                        _.get(this, "props.isRTLFlow", false) || isInputDisable
                          ? "disabled"
                          : ""
                      }
                      className="btn-link btn-send"
                      type="button"
                      onClick={e => this.sendMessageBtn(e)}
                    >
                      {_.get(this, "props.isRTLFlow", false) && (
                        <img
                          src={require(`./../../public/images/send-reverse.svg`)}
                          alt=""
                        />
                      )}
                      {ENVIORMENT.project === "al-ain" &&
                        _.get(this, "props.isRTLFlow", false) === false && (
                          <img
                            src={require(`./../../public/images/send.svg`)}
                            alt=""
                          />
                        )}
                      {ENVIORMENT.project === "medcare" &&
                        _.get(this, "props.isRTLFlow", false) === false && (
                          <img
                            src={require(`./../../public/images/send-medcare.svg`)}
                            alt=""
                          />
                        )}
                    </button>
                  </div>
                </div>
                <PoweredBy />
              </div>
            </div>
            <div
              className={
                "chat-body agent-parent-container " +
                (!_.get(this, "state.isLiveAgentOpen", false) ? "d-none" : "")
              }
            >
              <iframe
                ref={el => {
                  this.liveAgentContainer = el;
                }}
                name="live-agent-container"
                className="chat-body live-agent-container"
                title="Connect with Live Agent"
              />
              <div className="text-center">
                <button
                  className="btn btn-sm m-2 btn-bbl"
                  onClick={e => {
                    // this.setState({
                    //   isLiveAgentOpen: false
                    // }, () => {
                    this.liveAgentContainer.attributes.src = "";
                    this.toggleLiveAgent(false);
                    this.sendQuickReply("Live Agent Ended", false);
                    // })
                  }}
                >
                  End Chat with Live Agent
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChatScreen;
